export const AppConfig = {
    app: {
        name: 'Cartera Financiera',
        version: '1.0'
    },
    company: {
      name: 'DevTeam',
      copyright: 2021
    }
};
